export default "__VITE_ASSET__C1Nj56uU__"